'use client'

import {
  clickEvent,
  inboxConversationClickEvent,
  messagingClickEvent,
} from '@marketplace-web/messaging/tracking-data'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { BrazeListItem } from '@marketplace-web/braze/braze-feature'
import {
  ConversationListItemType,
  useConversationContext,
  useConversationSidebarContext,
} from '@marketplace-web/messaging/conversation-providers-feature'

import InboxListItem from '../InboxListItem'
import { isBrazeConversation } from '../../utils'

type Props = {
  conversation: ConversationListItemType
}

const ConversationListItem = ({ conversation }: Props) => {
  const { track } = useTracking()
  const { closeSidebar } = useConversationSidebarContext()
  const { conversation: activeConversation, setConversation } = useConversationContext()

  const handleClick = () => {
    if (isBrazeConversation(conversation)) {
      track(clickEvent({ target: 'message_reply' }))

      return
    }

    track(
      inboxConversationClickEvent({
        conversationId: String(conversation.id),
        lastMessageId: String(conversation.last_message_id),
      }),
    )
    track(
      messagingClickEvent({
        target: 'open_conversation',
        conversationId: conversation.id,
        info: conversation.unread ? 'unseen' : 'seen',
        screen: 'inbox',
      }),
    )
  }

  if (isBrazeConversation(conversation)) {
    return (
      <BrazeListItem
        card={conversation}
        onClick={handleClick}
        onCloseSidebar={closeSidebar}
        onSetConversation={setConversation}
        activeConversation={activeConversation}
      />
    )
  }

  return <InboxListItem conversation={conversation} onClick={handleClick} />
}

export default ConversationListItem
